<template>

  <div class="product_item">
    <div class="product_col-summery">
      <div class="box_product-summery">
        <div class="summery_col-thumb" v-if="product.item_name != '포장비'">
          <a class="link_product" :href="product.outlink" target="_blank">
            <img :src="product.img_url" :alt="`img`"></a>
        </div>
        <div class="summery_col-thumb" v-else>
          <div class="link_product">
            <img :src="product.img_url" :alt="`img`">
          </div>
        </div>
        <div class="summery_col-info">
          <a class="link_product">
            <div class="product_text-data">
              <p class="text_product-title"> {{ product.item_name }} </p>
            </div>
          </a>

          <div class="product-stock has-promotion-stock" v-if="product.promotionYN">
            <div class="promotion">
              <div class="lightBlue pointer promotion-tip">
                <button type="button" class="tooltip-btn">프로모션
                  내용</button>
              </div>
              <div class="promotion-tip-alert">
                <div class="txt-wrap">
                  <p>아티스트리 워터 에센스 선 프로텍트</p>
                  <p>SPF50+ PA++++ 2개 구매 시, 아티스트리 워터</p>
                  <p>에센스 선 프로텍트 미니 1개 증정</p>
                </div>
                <div class="txt-btn-detail"><a
                  href="#"><span>프로모션 상세보기</span></a>
                </div>
                <div class="tip-close">
                  <button type="button"
                          class="tooltip-closed">창닫기</button>
                </div>
              </div>
            </div>
            <div class="cartlist-instock">
              <span class="green">
                <a href="#">
                  <span class="icon icon-check-bold"></span>
                  <span class="text text-uppercase">적용</span>
                </a>
              </span>
            </div>
          </div>



          <div class="box_mobile-price box_product-price">
            <div class="text_product-state">
              <div class="state_title">수량</div>
              <div class="state_contents"><span
                class="state_data"> {{ product.dose_cnt }} </span></div>
            </div>
            <div class="text_product-price unit">
              <div class="price_title">단가</div>
              <div class="price_contents"><span
                class="text_price-data"> {{ thousandSeparator(product.price) }} </span>원
              </div>
            </div>
            <div class="text_product-price">
              <div class="price_title">소계</div>
              <div class="price_contents"><span
                class="text_price-data"> {{ thousandSeparator(product.total_price)  }}</span>원
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- TODO PC화면 상품 수량 및 가격 정보 -->
    <div class="product_col-panels">
      <!--내용 없음-->
    </div>
    <div class="product_col-panels">
      <div class="text_product-state">
        <div class="state_title">수량</div>
        <div class="state_contents"><span class="state_data">{{ product.dose_cnt }}</span>
        </div>
      </div>
    </div>
    <div class="product_col-price box_product-price">
      <div class="text_product-price unit">
        <div class="price_title">단가</div>
        <div class="price_contents"><span
          class="text_price-data">{{ thousandSeparator(product.price) }}</span>원</div>
      </div>
      <div class="text_product-price">
        <div class="price_title">소계</div>
        <div class="price_contents"><span
          class="text_price-data">{{ thousandSeparator(product.total_price) }}</span>원</div>
      </div>
    </div>
    <div class="product_col-del">
      <!-- 삭제 버튼 없음 -->
    </div>
  </div>
</template>

<script>
import { thousandSeparator } from '@/utils/common';

export default {
  name: "ProductRow",
  methods: { thousandSeparator },
  props: {
    product: {
      type: Object,
      required: true,
      default: () => {
        return {
          dose_cnt: 120,
          img_url: "/static/images/thumbs/303694K.jpg",
          item_name: "아세로라C",
          item_sku: "303694K",
          outlink: "https://www.uat.amway.co.kr/p/303694K/mpn",
          promotionYN: "false",
          price: 230,
          total_price: 27600
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
